import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPPhotos from 'data-hooks/usePDPPhotos/index';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import { getMainImageImgixPropsForPhoto, getThumbnailImageImgixPropsForPhoto } from './helpers/imgix-props';
import Prefetcher from '../../../essentials/Prefetcher';
import PDPDesktopHeroGalleryUI from './PDPDesktopHeroGalleryUI';
import usePDPDesktopHeroSizeProps from './helpers/usePDPDesktopHeroSizeProps';
const getPrefetcherConfig = (lastHoveredConfigPhotos, selectedPhoto, enableCrops, mainPhotoSizeProps) => {
  if (!selectedPhoto || !lastHoveredConfigPhotos.length) {
    return {};
  }
  const mainPhoto = lastHoveredConfigPhotos[selectedPhoto.type === 'studio' || !lastHoveredConfigPhotos[selectedPhoto.index] ? 0 : selectedPhoto.index];
  if (!mainPhoto.src) {
    return {};
  }
  const onRenderAssets = [...lastHoveredConfigPhotos.slice(0, 5).map(({
    src,
    type
  }) => ({
    url: src,
    imgixProps: getThumbnailImageImgixPropsForPhoto({
      src,
      type
    })
  })), {
    url: mainPhoto.src,
    imgixProps: {
      ...getMainImageImgixPropsForPhoto(mainPhoto, enableCrops),
      ...mainPhotoSizeProps
    },
    isProductImage: true
  }];
  return {
    onRenderAssets
  };
};
const PDPDesktopHeroGallery = t0 => {
  const $ = _c(67);
  const {
    isEditOrder: t1,
    mainPhotoLink,
    mode: t2,
    pdpIsModularBYOProduct,
    slug
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const {
    loading,
    error,
    data,
    actions
  } = usePDPPhotos(null, slug);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let modularPhotosData = useModularPDPPhotos(null, slug);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const mainPhotoSizeProps = usePDPDesktopHeroSizeProps();
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      isPDPDesktop: true
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    cylindoConfigurationPhotos,
    isCylindoConfigurationPhotos,
    dimensionShotUrls,
    currentDimensionShot,
    selectedDimensionShotIndex,
    hasMultipleDimensionShots,
    shouldShowDimensionThumbnail,
    goToNextDimensionShot,
    goToPreviousDimensionShot
  } = usePDPCylindoViewer(t3);
  let t4;
  if ($[1] !== data || $[2] !== modularPhotosData?.data || $[3] !== pdpIsModularBYOProduct) {
    t4 = pdpIsModularBYOProduct ? modularPhotosData?.data ?? {} : data;
    $[1] = data;
    $[2] = modularPhotosData?.data;
    $[3] = pdpIsModularBYOProduct;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    campaign,
    configurationPhotos: nonCylindoConfigurationPhotos,
    dimensionalImage,
    enableCrops,
    introVideoIds,
    isConfigFlipped,
    isVideoSelected,
    lastHoveredConfigPhotos,
    productName,
    selectedPhoto,
    studioPhotos: allStudioPhotos
  } = t4;
  const configurationPhotos = useRemoveBrokenImageUrls(isCylindoConfigurationPhotos ? cylindoConfigurationPhotos : nonCylindoConfigurationPhotos);
  const studioPhotos = useRemoveBrokenImageUrls(allStudioPhotos);
  let t5;
  if ($[5] !== actions || $[6] !== modularPhotosData?.actions || $[7] !== pdpIsModularBYOProduct) {
    t5 = pdpIsModularBYOProduct ? modularPhotosData?.actions ?? {} : actions;
    $[5] = actions;
    $[6] = modularPhotosData?.actions;
    $[7] = pdpIsModularBYOProduct;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    setSelectedPhoto,
    setIsVideoSelected
  } = t5;
  let t6;
  bb0: {
    if (selectedPhoto?.type === "dimensional") {
      if (currentDimensionShot) {
        let t7;
        if ($[9] !== currentDimensionShot.dimensionCode || $[10] !== currentDimensionShot.src || $[11] !== selectedPhoto) {
          t7 = {
            ...selectedPhoto,
            src: currentDimensionShot.src,
            dimensionCode: currentDimensionShot.dimensionCode
          };
          $[9] = currentDimensionShot.dimensionCode;
          $[10] = currentDimensionShot.src;
          $[11] = selectedPhoto;
          $[12] = t7;
        } else {
          t7 = $[12];
        }
        t6 = t7;
        break bb0;
      }
      if (dimensionalImage?.src) {
        let t7;
        if ($[13] !== dimensionalImage.src || $[14] !== selectedPhoto) {
          t7 = {
            ...selectedPhoto,
            src: dimensionalImage.src
          };
          $[13] = dimensionalImage.src;
          $[14] = selectedPhoto;
          $[15] = t7;
        } else {
          t7 = $[15];
        }
        t6 = t7;
        break bb0;
      }
      t6 = selectedPhoto;
      break bb0;
    }
    if (isCylindoConfigurationPhotos && selectedPhoto?.type === "cylindo") {
      t6 = selectedPhoto;
      break bb0;
    }
    if (isCylindoAvailable && !selectedPhoto) {
      if (isCylindoConfigurationPhotos) {
        t6 = cylindoConfigurationPhotos[0];
        break bb0;
      }
      let t7;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          type: "cylindo"
        };
        $[16] = t7;
      } else {
        t7 = $[16];
      }
      t6 = t7;
      break bb0;
    }
    if (!isCylindoAvailable) {
      t6 = selectedPhoto || studioPhotos[0];
      break bb0;
    }
    t6 = selectedPhoto || studioPhotos[0];
  }
  const selectedPhotoToShow = t6;
  let t7;
  if ($[17] !== currentDimensionShot || $[18] !== dimensionalImage || $[19] !== selectedPhoto?.type) {
    t7 = () => {
      if (currentDimensionShot) {
        return currentDimensionShot;
      }
      if (selectedPhoto?.type === "dimensional" && dimensionalImage?.src) {
        return {
          src: dimensionalImage.src,
          dimensionCode: "static",
          id: "static-dimensional"
        };
      }
      return {
        src: "",
        dimensionCode: "none",
        id: "no-dimensional-shot"
      };
    };
    $[17] = currentDimensionShot;
    $[18] = dimensionalImage;
    $[19] = selectedPhoto?.type;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  selectedPhoto?.type;
  let t8;
  if ($[21] !== t7) {
    t8 = t7();
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const currentDimensionShotToShow = t8;
  if (loading) {
    const t9 = pdpSelectedCustomizerTab === "decide-later";
    let t10;
    if ($[23] !== mode || $[24] !== t9) {
      t10 = <PDPDesktopHeroGalleryUI loading={true} mode={mode} showDecideLaterOverlay={t9} />;
      $[23] = mode;
      $[24] = t9;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    return t10;
  }
  if (!data) {
    return null;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  let t9;
  if ($[26] !== enableCrops || $[27] !== lastHoveredConfigPhotos || $[28] !== mainPhotoSizeProps || $[29] !== selectedPhoto) {
    t9 = getPrefetcherConfig(lastHoveredConfigPhotos, selectedPhoto, enableCrops, mainPhotoSizeProps);
    $[26] = enableCrops;
    $[27] = lastHoveredConfigPhotos;
    $[28] = mainPhotoSizeProps;
    $[29] = selectedPhoto;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  const t10 = pdpSelectedCustomizerTab === "decide-later";
  let t11;
  if ($[31] !== cylindoConfigurationPhotos || $[32] !== setSelectedPhoto) {
    t11 = t12 => {
      const {
        id,
        index,
        src,
        type
      } = t12;
      setSelectedPhoto?.(type === "cylindo" ? cylindoConfigurationPhotos[index] : {
        id,
        index,
        src,
        type
      });
    };
    $[31] = cylindoConfigurationPhotos;
    $[32] = setSelectedPhoto;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const t12 = !isCylindoAvailable;
  let t13;
  if ($[34] !== campaign || $[35] !== configurationPhotos || $[36] !== currentDimensionShotToShow || $[37] !== cylindoFeatures || $[38] !== dimensionShotUrls || $[39] !== dimensionalImage || $[40] !== enableCrops || $[41] !== goToNextDimensionShot || $[42] !== goToPreviousDimensionShot || $[43] !== hasMultipleDimensionShots || $[44] !== introVideoIds || $[45] !== isConfigFlipped || $[46] !== isCylindoAvailable || $[47] !== isCylindoConfigurationPhotos || $[48] !== isEditOrder || $[49] !== isVideoSelected || $[50] !== mainPhotoLink || $[51] !== mode || $[52] !== pdpIsModularBYOProduct || $[53] !== productName || $[54] !== selectedDimensionShotIndex || $[55] !== selectedPhotoToShow || $[56] !== setIsVideoSelected || $[57] !== shouldShowDimensionThumbnail || $[58] !== studioPhotos || $[59] !== t10 || $[60] !== t11 || $[61] !== t12 || $[62] !== viewGalleryImageEvent) {
    t13 = <PDPDesktopHeroGalleryUI configurationPhotos={configurationPhotos} selectedPhoto={selectedPhotoToShow} dimensionsImage={dimensionalImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} isEditOrder={isEditOrder} enableCrops={enableCrops} loading={false} showDecideLaterOverlay={t10} setSelectedPhoto={t11} dimensionShotUrls={dimensionShotUrls} currentDimensionShot={currentDimensionShotToShow} hasMultipleDimensionShots={hasMultipleDimensionShots} selectedDimensionShotIndex={selectedDimensionShotIndex} goToNextDimensionShot={goToNextDimensionShot} goToPreviousDimensionShot={goToPreviousDimensionShot} studioPhotos={studioPhotos} isConfigFlipped={isConfigFlipped} introVideoIds={introVideoIds} isVideoSelected={isVideoSelected} setIsVideoSelected={setIsVideoSelected} productName={productName} cylindoFeatures={cylindoFeatures} isCylindoAvailable={isCylindoAvailable} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} viewGalleryImageEvent={viewGalleryImageEvent} pdpIsModularBYOProduct={pdpIsModularBYOProduct} mode={mode} mainPhotoLink={mainPhotoLink} campaign={campaign} displayOnlyConfigImages={t12} />;
    $[34] = campaign;
    $[35] = configurationPhotos;
    $[36] = currentDimensionShotToShow;
    $[37] = cylindoFeatures;
    $[38] = dimensionShotUrls;
    $[39] = dimensionalImage;
    $[40] = enableCrops;
    $[41] = goToNextDimensionShot;
    $[42] = goToPreviousDimensionShot;
    $[43] = hasMultipleDimensionShots;
    $[44] = introVideoIds;
    $[45] = isConfigFlipped;
    $[46] = isCylindoAvailable;
    $[47] = isCylindoConfigurationPhotos;
    $[48] = isEditOrder;
    $[49] = isVideoSelected;
    $[50] = mainPhotoLink;
    $[51] = mode;
    $[52] = pdpIsModularBYOProduct;
    $[53] = productName;
    $[54] = selectedDimensionShotIndex;
    $[55] = selectedPhotoToShow;
    $[56] = setIsVideoSelected;
    $[57] = shouldShowDimensionThumbnail;
    $[58] = studioPhotos;
    $[59] = t10;
    $[60] = t11;
    $[61] = t12;
    $[62] = viewGalleryImageEvent;
    $[63] = t13;
  } else {
    t13 = $[63];
  }
  let t14;
  if ($[64] !== t13 || $[65] !== t9) {
    t14 = <Prefetcher {...t9}>{t13}</Prefetcher>;
    $[64] = t13;
    $[65] = t9;
    $[66] = t14;
  } else {
    t14 = $[66];
  }
  return t14;
};
PDPDesktopHeroGallery.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  mainPhotoLink: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string
};
export default PDPDesktopHeroGallery;